import { getCardModelFields } from "./functions";

const GAME_LABEL = "Pokemon TCG";
// espelha api/utils/cards/modelFields.js do backend
const LANGUAGE_NAMES = {
    en: "English", pt: "Portuguese", ja: "Japanese", "zh-tw": "Chinese", "zh-cn": "Chinese", ko: "Korean",
    id: "Indonesian", th: "Thai", fr: "French", it: "Italian", es: "Spanish", de: "German",
};
const normalizeLang = (lang) => {
    const l = String(lang ?? "").trim().toLowerCase();
    return l === "pt-br" || l === "ptbr" ? "pt" : l;
};
const MODEL_FIELDS = ["game", "name", "edition", "year", "language", "numbering", "rarity"];

export const pick = (current, next) => (current === undefined || current === null || String(current).trim() === "" ? next : current);

/**
 * Preenche só os campos vazios. Com `modelFields` (GET /admin/cards/tcgdex/:cardId/model-fields,
 * spec 2026-10-01 §5) usa o padrão dos modelos; sem ele, o preenchimento parcial pela carta.
 */
export const prefillFromCard = (current, card, lang, modelFields = null) => {
    if (modelFields) {
        const out = { ...current };
        MODEL_FIELDS.forEach((key) => {
            const value = modelFields[key];
            out[key] = pick(current[key], value === undefined || value === null ? "" : String(value));
        });
        return out;
    }
    return {
        ...current,
        game: pick(current.game, GAME_LABEL),
        name: pick(current.name, card.name || ""),
        edition: pick(current.edition, card.setName || ""),
        language: pick(current.language, LANGUAGE_NAMES[normalizeLang(lang)] || lang || ""),
        numbering: pick(current.numbering, card.localId || ""),
        rarity: pick(current.rarity, card.rarity || ""),
    };
};

/** Busca o model-fields da carta; falha do backend/TCGdex mantém o preenchimento parcial. */
export const fillFromCard = async (token, current, card) => {
    const out = await Promise.resolve(getCardModelFields(token, card.cardId, card.lang)).catch(() => null);
    return prefillFromCard(current, card, card.lang, out?.type === "success" ? out.data : null);
};
